/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

(function (M, _, $, Backbone) {
  "use strict";

  M.View = M.View || {};
  M.View.Design = M.View.Design || {};

  /**
   * @class M.View.Design.PollOption
   *
   */
  M.View.Design.PollOption = Backbone.View.extend({
    tagName: 'div',
    className: 'option floatL',
    events: {
      'click :not(.zoomIcon)': 'vote',
      'click .zoomIcon': 'renderVoteView',
      'click .optionImage': 'fileUploadDialog',
      'fileuploadsubmit .fileupload': 'fileUploadSubmit',
      'fileuploadprogress .fileupload': 'fileUploadProgress',
      'fileuploaddone .fileupload': 'fileUploadDone',
      'fileuploadfail .fileupload': 'fileUploadFail'
    },
    options: {
      useMinimalTemplate: false,
      hideResults: false,
      disableSelecting: false
    },

    template: M.Template.Design.PollOption,
    templateMinimal: M.Template.Design.PollOptionMinimal,

    initialize: function() {
      this.$el = $(this.el);
      _.extend(this, this.options.renderData);
      this.userIsDesigner = this.options.userIsDesigner;

      var votes = this.poll.get('votes');
      if (votes) {
        this.votes = votes[this.model.id] || {};
      }

      this.addClasses();
    },

    hasVote: function() {
      return !this.model.isNew() && this.user.vote;
    },

    isSelectedOption: function() {
      return this.hasVote() && this.user.vote == this.model.id;
    },

    addClasses: function () {
      // If the user voted for this option, give this option the selected
      // class.
      if (this.isSelectedOption()) {
        this.$el.addClass('selected');
      } else if (this.hasVote() && !this.isSelectedOption()) {
        this.$el.addClass('notSelected');
      }

      // If we have a this.index property, convert the index to this option's
      // name.
      if (this.index >= 0) {
        this.name = this.constructor.indexToLetter(this.index);
        this.$el.addClass(this.name);

        // If this.index is an even number, use 960 grid's alpha class, and
        // if it is an odd number use the omega class. This allows for the
        // 4 options to be in a 2x2 grid inside the poll.
        if (this.index % 2 === 0) {
          this.$el.addClass('alpha clear');
        } else {
          this.$el.addClass('omega');
        }
      }

      if (this.model.isNew()) {
        this.$el.addClass('isNew');
      } else if (this.userIsDesigner) {
        this.$el.addClass('defaultCursor');
      }
    },

    render: function() {
      var totalVoteCount = null;
      if (this.poll.get('votes')) {
        totalVoteCount = this.poll.get('votes').total_vote_count;
      }
      var templateVars = {
        option: this,
        totalVoteCount: totalVoteCount
      };

      var templateToUse = this.template;
      if (this.options.useMinimalTemplate) {
        templateToUse = this.templateMinimal;
      }
      this.$el.html(templateToUse(templateVars));
      this.afterRender();
      return this;
    },

    /**
     * Does some DOM setup, presumably after this.el has been inserted into
     * the DOM. Sets up the file upload ui, as well as the vote results area.
     */
    afterRender: function() {
      // Set up file upload ui
      this.fileuploadProgressbar = this.$('.fileuploadProgressbar').
        progressbar();
      this.imageWrapper = this.$('.optionImage');
      this.getFileUploader().fileupload({
        dropZone: this.imageWrapper
      });
      if (this.options.disabled) {
        this.disable();
      }
      if (this.options.useMinimalTemplate && !this.options.disableSelecting) {
        var $overlay = this.$el.find('.designImageBox .designOverlayContainer');
        this.$el.find('.designImageBox').hover(
          function() { $overlay.show(); },
          function() { $overlay.hide(); }
        );
      }

      // Set up vote result area
      this.resultProgressbar = this.$('.result.progressbar');
      if (this.votes) {
        this.resultProgressbar.progressbar({
          value: this.votes.percent || 0
        });
      }
    },

    /**
     * This gets the file uploader. The file input element sometimes gets
     * replaced with a clone. See information here:
    https://github.com/blueimp/jQuery-File-Upload/wiki/Options#replacefileinput
     *
     * @return {jQuery} A jquery object for the file upload field.
     */
    getFileUploader: function () {
      return this.$('input.fileupload');
    },

    fileUploadDialog: function (e) {
      if (this.model.isNew()) {
        e.stopPropagation();
        this.getFileUploader().click();
      }
    },

    fileUploadSubmit: function (e, data) {
      this.canDisable = false;
      this.fileuploadProgressbar.progressbar('value', 0).show();
      this.trigger('fileuploadsubmit');
    },

    fileUploadProgress: function (e, data) {
      var progress = Math.round(data.loaded / data.total * 100);
      this.fileuploadProgressbar.progressbar('value', progress);
    },

    /**
     * When the file upload finishes, we store information returned from the
     * server about the file in the model so that when the poll is created we
     * can store that information in the database. We also display the image
     * with the url the server returned and remove the file upload progressbar.
     *
     * @param {event} e The jQuery event object
     * @param {object} data The data from the server. data.result is the value
     * that the server returns. This object contains an image_path and a
     * thumb_path, which are the urls to the respective images.
     */
    fileUploadDone: function (e, data) {
      var that = this;
      this.model.set({
        image: data.result.image_path,
        thumb: data.result.thumb_path
      });

      // This makes the progressbar appear to load indeterminitely:
      // http://api.jqueryui.com/progressbar/#option-value
      this.fileuploadProgressbar.progressbar('value', false);

      // Make a new image with the url returned from the server and wait for it
      // to load. Once it loads, hide the progressbar and show the image.
      var image = new Image();
      image.src = this.model.get('image');
      image.onload = _.bind(function() {
        that.fileuploadProgressbar.hide();
        var img = this.imageWrapper.find('img');
        img.attr('src', image.src);
        this.imageWrapper.css('height', '');
        this.$('.uploadImageButton').hide();
      }, this);
    },

    fileUploadFail: function (e, data) {
      alert('This file could not be uploaded. Please ensure your file is no ' +
           'larger than 550px by 550 px and that it is a valid file type.');
      this.fileuploadProgressbar.progressbar('value', 0);
      this.trigger('fileuploadfail');
    },

    canVote: function () {
      return !this.model.isNew() && !this.userIsDesigner &&
        !this.options.disableSelecting;
    },

    /**
     * Trigger the castVote event which the poll view object responds to.
     * The ultimate result of this process is that a vote gets cast on the
     * server.
     *
     * @param {jQuery.Event} e event
     */
    vote: function (e) {
      if (this.canVote()) {
        e.stopPropagation();
        this.trigger('castVote');
      }
    },

    /**
     * Render the vote view, which shows a larger version of each design
     * and allows you to cast a vote from there.
     *
     * @param {jQuery.Event} e event
     */
    renderVoteView: function(e) {
      if (this.canVote()) {
        e.stopPropagation();
        this.trigger('renderVoteView');
      }
    },

    /**
     * This disables file uploading for this option. If the user has already
     * begun uploading a file for this option, this.canDisable will be false and
     * it will not be disabled. Called when the previous option's file upload
     * failed.
     */
    canDisable: true,
    disable: function() {
      if (this.canDisable && this.model.isNew()) {
        this.getFileUploader().attr('disabled', true);
        this.$el.addClass('disabled');
      }
    },

    /**
     * Enables file uploading for this option. Called when the previous option's
     * file upload begins.
     */
    enable: function() {
      this.getFileUploader().attr('disabled', false);
      this.$el.removeClass('disabled');
    }
  }, {
    /**
     * Converts a number (0-4 in practice, but 0-25 would technically work) to a
     * letter. Useful for converting 0 to "a", 1 to "b" and so on so that we can
     * display options by letter in the ui.
     *
     * @param {number} idx The index of this option in the options collection.
     * @returns {string} The corresponding letter name of this option.
     */
    indexToLetter: function (idx) {
      return String.fromCharCode(97 + idx);
    }
  });

})(M, _, $, Backbone);

